import { AnalyticsBrowser } from '@segment/analytics-next';
import { createContext } from 'react';

export interface AnalyticsContextProps {
  analytics: AnalyticsBrowser | null;
}

export const AnalyticsContext = createContext(null);
